import React from 'react';
import {
    Box,
    Button,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import {ColumnType, resolveNameForColumnType} from "../../api/enum/ColumnType";
import NotesIcon from "@mui/icons-material/Notes";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import NumbersIcon from "@mui/icons-material/Numbers";
import LinkIcon from "@mui/icons-material/Link";
import EditIcon from "@mui/icons-material/Edit";
import {AnyColumnJson} from "../../api/json/ColumnJson";
import {ProjectJson} from "../../api/json/ProjectJson"
import ColumnIssueIcon from "./ColumnIssueIcon"
import InlineCode from "../common/InlineCode"

interface ColumnsTableProps {
    project: ProjectJson
    columns: AnyColumnJson[]
    handleEdit: (column: AnyColumnJson) => void
}

function ColumnsTable({ project, columns, handleEdit }: ColumnsTableProps) {
    const sortedFields = columns.sort((a,b) => a.order - b.order)
    return (
        <Box>
            <TableContainer component={Paper} sx={{pt:1, pb:1}}>
                <Table aria-label="classifications table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Reference</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedFields.map(column => (
                            <TableRow
                                key={column.id}
                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                            >
                                <TableCell>
                                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
                                        <ColumnIssueIcon project={project} column={column}/>
                                        <Typography variant="body1">{column.name}</Typography>
                                    </Stack>
                                </TableCell>
                                <TableCell>
                                    <InlineCode>{column.reference}</InlineCode>
                                </TableCell>
                                <TableCell>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        {column.type === ColumnType.TEXT && <NotesIcon fontSize="small"/>}
                                        {column.type === ColumnType.PREDEFINED_OPTIONS &&
                                            <FormatListBulletedIcon fontSize="small"/>}
                                        {column.type === ColumnType.NUMBER && <NumbersIcon fontSize="small"/>}
                                        {column.type === ColumnType.URL && <LinkIcon fontSize="small"/>}
                                        <Typography
                                            variant="body2">{resolveNameForColumnType(column.type)}</Typography>
                                    </Stack>
                                </TableCell>
                                <TableCell align="right">
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<EditIcon/>}
                                        onClick={(event) => handleEdit(column)}
                                    >
                                        Edit
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default ColumnsTable;